import React, { useEffect } from "react";
import AllRoute from "../router";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addUserCart, updateConfigs ,logout} from "../../store/actions/action";
import { connect } from "react-redux";
import LoginModal from "../../components/Modal/LoginModal";
import WhatsAppButton from "../../components/WhatsAppButton/WhatsAppButton";
import BrandLoader from "../../components/BrandLoader/BrandLoader";
import { useCart } from "../../Context/CartContext";
import axios from "axios";
import { isEmpty } from "lodash";
import { checkLoggedIn } from "../../utils";
import { store } from "../../store/index";


const currency = localStorage.getItem("currency") || "AED";

axios.interceptors.request.use(
  function (config) {
    // Add the currency to the headers (or as a query parameter)


    if (config.params) {
      config.params.currency = currency;
    } else {
      // If params does not exist, create it and add currency
      config.params = { currency };
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const logoutUrls = ["get-cart", "userdetails", "/auth/orders"];
    const responseURL = error?.request?.responseURL;
    if (error.response) {
      if (error.response.status === 401 && checkLoggedIn()) {
        if (logoutUrls.some((url) => responseURL?.includes(url))) {
          store?.dispatch(logout());
        }
      }
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log("Error", error.message);
    }
    return Promise.reject(error);
  }
);

const App = (props) => {


  const { updateConfigs, configs, carts } = props;
  const { isAuth, token } = configs;
  const { cart, getUserCartData } = useCart();

  // Initial-boot loader. Stays visible until admin_conditions are fetched (or
  // failed). Also bridges the brief moment after a currency-switch reload —
  // HeaderMiddle sets `ggp_currency_switching` in sessionStorage right before
  // window.location.reload(), and we keep the splash up + show a tailored
  // caption until configs land.
  const [bootLoading, setBootLoading] = React.useState(true);
  const [isCurrencyReload] = React.useState(() => {
    if (typeof window === "undefined") return false;
    return sessionStorage.getItem("ggp_currency_switching") === "1";
  });

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((response) => response.json())
      .then((data) => {
        updateConfigs({
          ip_data: { country_calling_code: data?.country_calling_code },
        });
      })
      .catch((error) => console.error("Error fetching IP info:", error));
    handelGetAdminConditions();
  }, []);

  const handelGetAdminConditions = async () => {
    await axios
      .get("get-logo")
      .then((res) => {
        updateConfigs({ admin_conditions: res?.data?.data });
      })
      .catch((err) => {
        toast?.error(err?.response?.data?.message);
      })
      .finally(() => {
        // Small min-display so the splash doesn't flicker on fast networks.
        setTimeout(() => {
          setBootLoading(false);
          sessionStorage.removeItem("ggp_currency_switching");
        }, isCurrencyReload ? 250 : 400);
      });
  };

  useEffect(() => {
    if (isAuth && token) {
      (async () => {
        await getUserCartData();
      })();
    }
  }, [isAuth, token]); //  load the card data on the login

  return (
    <div className="App" id="scrool">
      <AllRoute />
      <ToastContainer
        position="top-right"
        hideProgressBar
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <LoginModal />
      <WhatsAppButton />
      {bootLoading && (
        <BrandLoader
          label={
            isCurrencyReload
              ? `Updating to ${(typeof window !== "undefined" && localStorage.getItem("currency")) || "AED"}`
              : "Loading"
          }
          sublabel={
            isCurrencyReload
              ? "Refreshing prices in your selected currency..."
              : "Preparing your premium experience..."
          }
        />
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    configs: state?.configs,
    token: state?.configs?.token,
    carts: state?.cartList?.cart,
    wish: state?.wishList?.w_list,
    compare: state?.compareList?.compare_list,
  };
};
export default connect(mapStateToProps, {
  updateConfigs,
  addUserCart,
  logout
})(App);
